<!-- src/App.vue -->

<template>
  <v-app>
    <overlay-loading-screen :isSaving="isBusy"></overlay-loading-screen>
    <!-- Toolbar with background image -->
    <v-app-bar v-if="showNavbar" class="custom-app-bar" :elevation="1" scroll-behavior="elevate">
      <!-- Toolbar title and menu items (hidden on small screens) -->
      <v-toolbar-title>
        <v-row class="align-center" no-gutters style="width: 100%">
          <v-col v-for="(item, index) in menuItems" :key="index">
            <v-btn v-if="item.auth" @click="item.action">
              {{ item.title }}
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar-title>
    </v-app-bar>

    <!-- Content -->
    <router-view />
  </v-app>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { computed, onBeforeUnmount, ref } from 'vue'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from './firebase'
import { UseCustomerStore } from './stores/CustomerStore'
import { RouteNames } from './router'
import OverlayLoadingScreen from './components/HelperComponents/OverlayLoadingScreen.vue'

const router = useRouter()
const route = useRoute()
const sessionData = UseCustomerStore()
const isSignedIn = ref(!!auth.currentUser)
const stopAuth = onAuthStateChanged(auth, (user) => {
  isSignedIn.value = !!user
})
onBeforeUnmount(stopAuth)

const showNavbar = computed(() => {
  return !route.matched.some((r) => r.path === '/home')
})

const isBusy = computed(() => sessionData.isBlockingLoad)

const handleSignin = () => {
  router.push({ name: RouteNames.SignIn })
}

const goToAbout = () => {
  router.push({ name: RouteNames.About })
}
const goToPricing = () => {
  router.push({ name: RouteNames.Pricing })
}
// Public (no sign-in): applicants submit a Practical Test Application.
const goToCheckRides = () => {
  router.push({ name: RouteNames.CheckRides })
}

const menuItems = computed(() => [
  {
    title: 'Dashboard',
    action: () => router.push({ name: RouteNames.HomeDashboard }),
    auth: isSignedIn.value
  },
  { title: 'About', action: goToAbout, auth: true },
  { title: 'Pricing', action: goToPricing, auth: true },
  { title: 'CHECK RIDES', action: goToCheckRides, auth: true },
  { title: 'Examiner', action: () => router.push({ name: RouteNames.Examiner }), auth: true },
  // Every public page, Check Rides and Examiner included.
  { title: 'Sign In', action: handleSignin, auth: !isSignedIn.value }
])
</script>

<style scoped>
.photo-section {
  margin-bottom: 2rem;
}

.custom-app-bar {
  background-position: center;
  background-color: #13334a;
  height: 64px;
}

.v-toolbar-title {
  color: white;
}

.d-sm-none {
  display: none !important;
}

@media (max-width: 960px) {
  .d-sm-none {
    display: block !important;
  }

  .d-none {
    display: none !important;
  }
}
</style>

<style lang="scss" global>
:root {
  --sidebar-width: 200px;
  --orangeHighlight: #e36414;
  --orangeBase: #fca311;
  --text-bg-white: #fcfcfc;
  --light-blue: #4f7288;
  --medium-blue: #194866;
  --dark-blue-alt: #13334a;
  --grey: #b3b3b3;
}

/* Autocomplete dropdown - remove box-in-box */
.v-autocomplete__content {
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

/* Orange hover/active on list items */
.v-list-item:hover {
  background-color: var(--orangeHighlight) !important;
  color: white !important;
}

.v-list-item--active {
  background-color: var(--orangeHighlight) !important;
  color: white !important;
}
/* Autocomplete dropdown */
.v-autocomplete__content {
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

/* Orange hover/active on list items */
.v-list-item:hover {
  background-color: var(--orangeHighlight) !important;
  color: white !important;
}

.v-list-item:hover .v-list-item__overlay {
  opacity: 0 !important;
}

.v-list-item--active {
  background-color: var(--orangeHighlight) !important;
  color: white !important;
}

.v-list-item--active .v-list-item__overlay {
  opacity: 0 !important;
}
.v-list-item .v-ripple__container {
  display: none !important;
}
.v-btn:hover .v-btn__overlay {
  opacity: 0 !important;
}

.v-btn:hover {
  background-color: var(--orangeHighlight) !important;
}

.v-btn .v-ripple__container {
  display: none !important;
}
.stdButton {
  display: flex;
  align-items: center;
  text-decoration: none;
  background-color: var(--dark-blue-alt);
  width: 100%;
  align-content: center;
  color: var(--text-bg-white);
  margin-bottom: 5px;

  text-align: center;

  transition: 0.2s ease-in-out;
  padding: 0.5rem 1rem;
}

.stdButton:hover {
  background-color: var(--orangeHighlight);
}
</style>
